<template>
    <div class="animated fadeIn activity-chart">
        <filters :scope="filtersScope">
        </filters>
        <div class="loader" v-if="isLoading"><i class="fa fa-spinner fa-spin fa-5x fa-fw"></i></div>
        <OperatorActivityChart v-for="(chart, i) in chartsData"
                               :key="i"
                               :title="Helper.getOperatorLogin(operators, i)"
                               :statistic="chart"
                               :id="i">
        </OperatorActivityChart>
    </div>
</template>


<script>
  import OperatorActivityChart from '../../../components/OperatorActivityChart.vue'
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Helper from '../../../api/Helper'
  import Storage from '../../../api/Storage'

  export default {
    name: 'Activity',
    components: {
      OperatorActivityChart,
      Filters
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          operatorFilter: true
        },
        chartsData: null,
        Helper: Helper,
        operators: [],
        isLoading: false
      }
    },
    mounted () {
      this.operators = Storage.operators.slice(0)
      this.$root.$on('filters_load_new_data', () => {
        this.calculate()
      })
      this.calculate()
    },
    methods: {
      calculate () {
        this.isLoading = true
        this.$root.$emit('data_loading')
        this.chartsData = []
        API.getOperatorActivity().then(response => {
          this.operators = Storage.operators.slice(0)
          this.chartsData = response.body.stat
          this.$root.$emit('data_loaded')
          this.isLoading = false
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.isLoading = false
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Activity.vue?0e774c4e